/* ============
 * State of the users module
 * ============
 *
 * The initial state of the users module.
 */

export default {
  users: [],
  projectRmDetails: {},
  customersAndBrokersList: [],
  drms: [],
  formulaData: null,
  devData: {},
  otherUsers: [],
  brokers: [],
};



// WEBPACK FOOTER //
// ./src/store/modules/users/state.js